import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 获取门店列表
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/store/getStoreList`, params),
    //修改门店列表
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/store/updateStore`, params),
    //新增门店
    adds: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/store/saveStore`, params),

    //获取商家产品列表
    gets: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/front/product/getProductOptions`, params),
    //色卡新增
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/saveColorcard`, params),

    //查询色卡新增列表
    getlist: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getColorcardList`, params),
    //删除色卡新增
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/deleteColorcard`, params),
    //修改色卡新增
    updates: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/updateColorcard`, params),

    //库存清点查询
    getsop: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getStockListForRectify`, params),
    //修改库存清点
    sopupdate: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/updateStock`, params),

    //色卡库存结存表查询列表
    getStock: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getStockList`, params),

    //色卡码列表与打印查询列表
    getdy: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getQrcodeList`, params),

    //每天色卡清单查询
    getqd: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getReceiveList`, params),
    //每天色卡清单修改
    updatess: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/updateReceive`, params),
    //每天色卡清单完成
    win: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/finishReceive`, params),

    //色卡-客户派发表查询列表
    getpf: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getColorcardDistribute`, params),

    //色卡领取名单查询列表
    getlq: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getColorcardReceiverList`, params),


    //每天色卡清单查询列表
    getDaily: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getFinishReceiveList`, params),
    //每天色卡清单修改列表
    upDaily: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/updateFinishReceive`, params),

    //销售派发色卡分析表
    getColorcardDistributeAnalysis: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/colorcard/getColorcardDistributeAnalysis`, params),
}